import store from "@/store";

export default async (to, from, next) => {
  if (to.name === "Checkout" && !store.getters.guestSessionId) {
    next({ name: "CartNotFound" });
  } else {
    next();
  }
};
